export default __webpack_public_path__ + "static/media/arrow-down-deep-blue-main.b8be934e.svg";